export default __webpack_public_path__ + "static/media/354.e834bc9f.png";